import { defineMessages } from "react-intl";
const messages = defineMessages({
    noUsers: {
        id: "app.admin.users.table.noData.text",
        defaultMessage: "No users available.",
    },
    name: {
        id: "app.admin.users.table.head.name.text",
        defaultMessage: "Name",
    },
    type: {
        id: "app.admin.users.table.head.type.text",
        defaultMessage: "Type",
    },
    id: {
        id: "app.admin.users.table.head.id.text",
        defaultMessage: "Id",
    },
    email: {
        id: "app.admin.users.table.head.email.text",
        defaultMessage: "Email",
    },
    organizations: {
        id: "app.admin.users.table.head.organization.text",
        defaultMessage: "Organizations",
    },
    communities: {
        id: "app.admin.users.table.head.communities.text",
        defaultMessage: "Communities",
    },
});
export default messages;
